import lazy from 'utils/lazy';

export const TechnicalBreak = lazy(() => import('./TechnicalBreak'));
